import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AppConfig } from 'src/app/api/helper/app.config';
import { WorkflowStatus } from 'src/app/api/model/swagger-model';
import { IAuftragdetails } from '../iauftragdetails';
import { NeutralWorkflowAktuelleAnsichtTyp } from 'src/app/api/model/model';
import { UiHelper } from 'src/app/api/helper/ui-helper';

const log = new Logger("AuftragMenuPopoverComponent");

@Component({
    templateUrl: './auftrag-menu-popover.component.html',
    styleUrls: ['./auftrag-menu-popover.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragMenuPopoverComponent implements OnInit, OnChanges {

    @Input() auftragdetails: IAuftragdetails;

    barcodeButtonVerfuegbar = AppConfig.current.einstellungen.AuftragBarcodeButtonVerfuegbar === 'ja';
    navigationVerfuegbar = true;
    weitereStatusmeldungenVerfuegbar = true;

    app = MyApp.current;
    buttonsWorkflowStatusList: WorkflowStatus[];

    isNeutralerWorkflow = false;

    isHandeingabeAktivierenVerfuegbar = false;

    constructor(
        private router: Router,
        private auftragService: AuftragService,
        private popoverController: PopoverController,
        protected cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.init();

        this.buttonsWorkflowStatusList = this.auftragdetails.buttons.filter(p => p.workflowStatus).map(p => p.workflowStatus);

        this.navigationVerfuegbar = this.auftragdetails.workflow.einstellungen.Navigation !== 'nein';
        this.weitereStatusmeldungenVerfuegbar = this.auftragdetails.workflow.status.length > this.buttonsWorkflowStatusList.length;

        this.isNeutralerWorkflow = this.auftragdetails.workflow.einstellungen?.Neutral === 'ja';

        // Bei THEURL soll die Handeingabe für die Wiegung aktiviert werden können.
        // Das hängt derzeit an der Waagen-Konfiguration.
        if (AppConfig.current?.einstellungen?.WaagenTyp === 'pfreundt') {
            this.isHandeingabeAktivierenVerfuegbar = true;
        }
    }

    init() {
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    onWeitereStatusmeldung() {
        log?.debug('onWeitereStatusmeldung');
        this.popoverController.dismiss();
        this.auftragdetails.onStatusmeldung();
    }

    onStarteNavigation() {
        log?.debug('onStarteNavigation');
        this.popoverController.dismiss();
        this.auftragdetails.starteNavigation(this.auftragdetails.auftrag.Abholadresse);
    }

    onAnzeigenBarcode() {
        log?.debug('onAnzeigenBarcode');
        this.popoverController.dismiss();
        this.auftragdetails.anzeigenBarcode();
    }

    onStoerzeiten() {
        log?.debug('onStoerzeiten');
        this.popoverController.dismiss();
        this.auftragdetails.anzeigenStoerzeiten();
    }

    istStatusuebergangErlaubt(workflowStatus: WorkflowStatus) {
        log?.debug('istStatusuebergangErlaubt: ' + workflowStatus?.name);

        if (!workflowStatus) {
            return true;
        }

        return this.auftragService.istStatusuebergangErlaubt(this.auftragdetails.auftrag, this.auftragdetails.workflow, workflowStatus);
    }

    onStatusmeldung(workflowStatus: WorkflowStatus) {
        log?.debug('onStatusmeldung', workflowStatus);
        this.popoverController.dismiss();
        this.auftragdetails.statusMelden(workflowStatus, true);
    }

    onAnsichtErzeuger() {
        log?.info('onAnsichtErzeuger');
        this.auftragdetails.setNeutralAktuelleAnsicht(NeutralWorkflowAktuelleAnsichtTyp.Erzeuger);
        this.popoverController.dismiss();
        this.cdr.detectChanges();
    }

    onAnsichtEntsorger() {
        log?.info('onAnsichtEntsorger');
        this.auftragdetails.setNeutralAktuelleAnsicht(NeutralWorkflowAktuelleAnsichtTyp.Entsorger);
        this.popoverController.dismiss();
        this.cdr.detectChanges();
    }

    async onAktiviereHandeingabe() {
        log?.info('onAnsichtEntsorger');

        const pin = AppConfig.current.einstellungen.PelletsWiegenHandeingabePIN;

        if (pin && pin !== 'aus') {
            const eingabe = await UiHelper.inputPIN();

            if (!eingabe) {
                // Abbruch
                return;
            }

            if (eingabe !== pin) {
                UiHelper.showAlert('Falscher PIN', 'Fehler');
                return;
            }
        }

        this.auftragdetails.auftrag.Zusatzdaten ??= {};
        this.auftragdetails.auftrag.Zusatzdaten.HandeingabeAktiviert = 'ja';

        this.auftragdetails.isHandeingabeErlaubt = true;
        this.auftragdetails.detectChanges.next('onAktiviereHandeingabe');

        this.popoverController.dismiss();
        this.cdr.detectChanges();
    }
}
